<template>
  <div>
    <BaseSheet
      :height="52"
      :elevation="this.$vuetify.breakpoint.xs ? 4 : 0"
      class="d-flex justify-space-between align-center px-4"
    >
      <span
        v-text="title"
        class="primary--text text-h6 font-weight-bold"
      ></span>
      <BaseButton
        @click="$store.dispatch('share/closeShareModal')"
        :disabled="closeActionDisabled"
        :icon="true"
      >
        <BaseIcon>close</BaseIcon>
      </BaseButton>
    </BaseSheet>
    <BaseDivider v-if="this.$vuetify.breakpoint.smAndUp"></BaseDivider>
  </div>
</template>

<script>
export default {
  name: "TheShareModalHeader",
  props: {
    title: {
      type: String,
      required: true
    },
    closeActionDisabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
